import React from "react";
import styled from "@emotion/styled";
import { Box, CircularProgress, useTheme } from "@mui/material";
import OuterRing from "./outer-ring.svg?react";
import InnerRing from "./inner-ring.svg?react";
import OuterRingThin from "./outer-ring-thin.svg?react";
import InnerRingThin from "./inner-ring-thin.svg?react";

const SpinnerContainer = styled(Box)<{ size?: "small" | "large" }>(
  ({ theme, size }) => ({
    position: "relative",
    transition: "width 0.5s, height 0.5s",

    ".outer-ring, .inner-ring": {
      position: "absolute",
      left: "50%",
      top: "50%",
      transformOrigin: "center",
      animationDuration: "2s",
      animationIterationCount: "infinite",
      animationTimingFunction: "linear",
    },

    ".inner-ring": {
      animationName: "spin-back",
      width: size === "small" ? "85%" : "87%",
      height: size === "small" ? "85%" : "87%",
    },

    ".outer-ring": {
      animationName: "spin-forth",
      width: "100%",
      height: "100%",
    },

    "@keyframes spin-back": {
      from: {
        transform: "translate(-50%, -50%) rotate(45deg)",
      },
      to: {
        transform: "translate(-50%, -50%) rotate(-315deg)",
      },
    },
    "@keyframes spin-forth": {
      from: {
        transform: "translate(-50%, -50%) rotate(45deg)",
      },
      to: {
        transform: "translate(-50%, -50%) rotate(405deg)",
      },
    },
  })
);

interface Props {
  width?: number;
  testId?: string;
  size?: "small" | "large";
}

export const LoadingSpinner = ({
  width = 500,
  testId,
  size = "small",
}: Props) => {
  const theme = useTheme();

  if (width < 30) {
    return <CircularProgress size={width} data-testid={testId} />;
  }

  return (
    <SpinnerContainer
      width={width}
      height={width}
      data-testid={testId}
      size={size}
    >
      {size === "small" ? (
        <OuterRing
          className="outer-ring"
          color={theme.palette.spinner.spinnerEllipseIn}
        />
      ) : (
        <OuterRingThin
          className="outer-ring"
          color={theme.palette.spinner.spinnerEllipseIn}
        />
      )}
      {size === "small" ? (
        <InnerRing
          className="inner-ring"
          color={theme.palette.spinner.spinnerEllipseOut}
        />
      ) : (
        <InnerRingThin
          className="inner-ring"
          color={theme.palette.spinner.spinnerEllipseOut}
        />
      )}
    </SpinnerContainer>
  );
};
